import { backendUrl } from "./backendUrl";

const API_URL = backendUrl("/Api/testimonials.php");

export async function getTestimonials() {
  const response = await fetch(API_URL, {
    cache: "no-store",
  });

  if (!response.ok) {
    throw new Error(`Unable to load testimonials: ${response.status}`);
  }

  const data = await response.json();

  if (!data.success || !Array.isArray(data.testimonials)) {
    throw new Error(data.message || "Invalid testimonials response");
  }

  return data.testimonials;
}
